export default "__VITE_ASSET__CLuwm_LR__"